import React from "react";
import { useTranslation } from "react-i18next";
import { Image } from "semantic-ui-react";
import { WEB_VERSION_V2_URL } from "../../../../auth/Auth0ProviderWithRedirect";
import LinkToIcon from "./assets/link-to.svg";
import styles from "./linkWithIcon.module.css";

export default function LinkWithIcon() {
  const { t } = useTranslation();
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      className={`link ${styles.linkWithIcon}`}
      href={`${WEB_VERSION_V2_URL}/settings/team-management`}
    >
      <span>
        {t("settings.inbox.channels.viewMessagesFromDefaultChannelsOnly.teams")}
      </span>
      <Image src={LinkToIcon} />
    </a>
  );
}
